import customSelect from 'custom-select'

class CustomSelectUI {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniSelect()
    }

    _iniSelect() {
        this.customSelect = customSelect(this.element)

        this.setWidth()
        this._addHelperElement()
    }

    setWidth() {
        this.customSelect[0].panel.style.cssText = 'position: relative'

        setTimeout(() => {
            this.customSelect[0].container.style.width = `${this.customSelect[0].panel.offsetWidth + 2}px`
            this.customSelect[0].panel.style.cssText = null
        })
    }

    _addHelperElement() {
        const errorHelper = document.createElement('div')
        errorHelper.classList.add('custom-select-helper')
        this.element.parentNode.insertBefore(errorHelper, this.element.nextSibling)
    }
}

export default CustomSelectUI
